import React from 'react';
import { Statistics, Numbers, Message, Loader, Icon } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import { fetcher } from '@weezevent/weezjs-core';
import { useInterval } from '../../../components/export/exportButton';
import i18n from 'i18next';

export default function CreditsCard({ organization }) {
    const { t } = useTranslation();
    const locale = i18n.language;
    const updateDelay = 30000;
    const [delay, setDelay] = React.useState(1);
    const [stats, setStats] = React.useState(null);

    const call = React.useCallback(() => {
        setDelay(updateDelay);
        fetcher.get(`/ticket/organizations/${organization.id}/ticket_office/credits`, { cache: false }).then(data => {
            if (data.status === 200) {
                setStats(data.response);
            }
        });
    }, [organization, updateDelay]);

    const moreCreditsUrl = stats?.book_more_url || window.weezConfig.moreCreditsURL || 'https://my.weezevent.com/fr-vente-sur-place-achat-de-credits-guichet';

    useInterval(call, delay);

    const StatisticsCredits = () => {
        if (!stats) {
            return <Statistics stat={<Loader />} style={{ minHeight: 111 }} />;
        }

        return (
            <Statistics
                title={t('ticket.ticket_offices.statistics_credits.subtitle')}
                titleHelp={
                    <>
                        {t('ticket.ticket_offices.statistics_credits.total')}
                        {':  '}
                        <Numbers locale={locale} value={stats.total} />
                    </>
                }
                stat={
                    <span style={{ color: 'rgb(var(--primary-color))' }}>
                        <Numbers locale={locale} value={stats.remaining} />
                    </span>
                }
                moreLabel={
                    <>
                        {t('ticket.ticket_offices.statistics_credits.buy')} <Icon name={'chevron-right'} size={'small'} />
                    </>
                }
                moreURL={moreCreditsUrl}
                propsURL={{ target: '_blank', rel: 'noopener' }}
            />
        );
    };

    return (
        <>
            {stats && stats.remaining <= 0 && (
                <Message
                    title={t('ticket.ticket_offices.statistics_credits.danger_title')}
                    type="danger"
                    links={{
                        label: t('ticket.ticket_offices.statistics_credits.buy'),
                        href: moreCreditsUrl
                    }}
                >
                    {t('ticket.ticket_offices.statistics_credits.danger_descr')}
                </Message>
            )}
            <Statistics.Group>{StatisticsCredits()}</Statistics.Group>
        </>
    );
}
